import * as types from './mutation-types'

export default {
  [types.SEAT_INIT] (state, result) {
    Object.assign(state, result)
  },

  [types.UPDATE_SELECTED_SEATS] (state, seats) {
    state.selectedSeats = seats
  },

  [types.CLEAR_SEAT] (state) {
    state.id = null
    state.name = null
    state.datetime = null
    state.limit = null
    state.prices = []
    state.seats = []
    state.selectedSeats = []
  }
}



// WEBPACK FOOTER //
// ./src/store/seat/mutations.js